/**
 * Haalt tijdelijke raster-exports uit editorstate voordat die wordt
 * opgeslagen of verstuurd. De bewerkbare Fabric/JSON-data blijft staan:
 * templates kunnen geneste SVG's bevatten die nodig zijn om een ontwerp
 * opnieuw te openen.
 */
export function compactDesignDataForPersistence(value: any): any {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;

  const compacted = { ...value };
  const isDataUrl = (candidate: unknown) =>
    typeof candidate === 'string' && candidate.startsWith('data:');

  // Voorbeschouwingen van het drukbestand. Samen met de Blob-URL maken ze
  // een JSON-PATCH groter dan Vercels request-body-limiet.
  if (isDataUrl(compacted.dataURL)) delete compacted.dataURL;
  if (isDataUrl(compacted.previewDataURL)) delete compacted.previewDataURL;

  if (compacted.printFile && typeof compacted.printFile === 'object' && !Array.isArray(compacted.printFile)) {
    const printFile = { ...compacted.printFile };
    if (isDataUrl(printFile.dataURL)) delete printFile.dataURL;
    compacted.printFile = printFile;
  }

  return compacted;
}

/** Compacte databasewaarde die naar de volledige editorstate wijst. */
export function isStoredDesignDataReference(value: any): value is { storageUrl: string } {
  return Boolean(
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    typeof value.storageUrl === 'string' &&
    value.storageUrl.startsWith('https://')
  );
}
